export default __webpack_public_path__ + "static/tag.circle-4527e37afeaf192cda9dda4835be55fc.png";